var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184 386L184 414",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.5,
    cy: 381.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.987 381.19C179.987 377.283 183.288 374.117 187.358 374.117C187.943 374.117 188.511 374.184 189.056 374.308C187.742 373.48 186.187 373 184.519 373C179.814 373 176 376.806 176 381.5C176 386.194 179.814 390 184.519 390C186.814 390 188.895 389.093 190.427 387.62C189.492 388.032 188.454 388.263 187.358 388.263C183.288 388.263 179.987 385.096 179.987 381.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.402 380.6L193.37 378.146L191.536 379.719L189.304 379.056L190.112 381.337L188.765 383.381L191.1 383.218L192.499 385.144L193.133 382.763L195.345 381.909L193.402 380.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.02e82094cae11df8da115602b6b5b960.svg";
export { ForwardRef as ReactComponent };